import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vShow as _vShow, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "form-group" }
const _hoisted_2 = {
  key: 0,
  class: "warning-text-wrap mt8 ml4"
}
const _hoisted_3 = {
  class: "form-group",
  style: {"margin-top":"32px"}
}
const _hoisted_4 = { class: "custom-control custom-checkbox show-edit-detail" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "form-group errors" }

import { computed, reactive } from 'vue';
import { useEditModalCommon } from 'src/composables/useEditModalCommon';
import type { AdminGroup2 } from 'src/models/group2';
import type { AdminGroup3 } from 'src/models/group3';
import type { AdminTagCreateParams, AdminTagUpdateParams } from 'src/models/apis/tag/adminTagRequest';
import type { TagInputModel } from 'src/models/tag';
import { createTagInitInputModel } from 'src/models/tag';

const tagNameTooLongMsg = '動画タグは全角16文字以内で入力してください';

// 半角は1文字、全角は2文字として計算

export default /*@__PURE__*/_defineComponent({
  __name: 'TagEditModal',
  props: {
    isEditMode: { type: Boolean },
    tag: {},
    groups2: {},
    groups3: {},
    isRequesting: { type: Boolean },
    httpErrorMsgs: {}
  },
  emits: ["create", "update", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const state = reactive<{ tag: TagInputModel; showEditDetail: boolean }>({
  tag: createTagInitInputModel(),
  showEditDetail: false,
});

const { editModalTitle } = useEditModalCommon(props, () => props.tag, (copied) => {
  state.tag = copied;
  state.showEditDetail = false;
});

const halfWidthLetterCount = (str: string): number => {
  let ret = 0;
  for (let i = 0, len = str.length; i < len; i++) {
    const asciiCode = str.charCodeAt(i);
    ret += asciiCode < 128 ? 1 : 2;
  }
  return ret;
};

const isTagNameTooLong = computed<boolean>(() => {
  return halfWidthLetterCount(state.tag.tagName) > 32;
});

const filteredGroups3 = computed<AdminGroup3[]>(() => {
  return props.groups3.filter(group3 => group3.parentId === state.tag.group2Id);
});

const validateTagForm = (tag: TagInputModel): boolean => {
  if (tag.tagName.length <= 0) return false;
  if (isTagNameTooLong.value) return false;
  if (!Number.isInteger(tag.group2Id)) return false;
  if (!Number.isInteger(tag.group3Id)) return false;

  return true;
};

const isSaveButtonDisabled = computed<boolean>(() => {
  return props.isRequesting || !validateTagForm(state.tag);
});

const createTag = (): void => {
  if (isSaveButtonDisabled.value) return;

  emit('create', {
    id: 0,
    tag_name: state.tag.tagName,
    group2_id: state.tag.group2Id ?? 0,
    group3_id: state.tag.group3Id ?? 0,
  });
};

const updateTag = (): void => {
  if (isSaveButtonDisabled.value || state.tag.id === null) return;

  emit('update', state.tag.id, {
    id: state.tag.id,
    tag_name: state.tag.tagName,
    group2_id: state.tag.group2Id ?? 0,
    group3_id: state.tag.group3Id ?? 0,
  });
};

const save = (): void => {
  if (props.isEditMode) {
    updateTag();
  } else {
    createTag();
  }
};

return (_ctx: any,_cache: any) => {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    title: _unref(editModalTitle),
    "bottom-close-button-label": "保存",
    isCloseButtonDisabled: isSaveButtonDisabled.value,
    onClose: save,
    onDismiss: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_1, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "form-control-label" }, "動画タグ", -1)),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            class: "form-control",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.tag.tagName) = $event))
          }, null, 512), [
            [_vModelText, state.tag.tagName]
          ]),
          (isTagNameTooLong.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createElementVNode("span", { class: "text-warning" }, "※" + _toDisplayString(tagNameTooLongMsg))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              class: "custom-control-input",
              id: "show-tag-edit-detail",
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.showEditDetail) = $event))
            }, null, 512), [
              [_vModelCheckbox, state.showEditDetail]
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("label", {
              class: "custom-control-label",
              for: "show-tag-edit-detail"
            }, " 詳細項目を表示する ", -1))
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_5, [
          _cache[8] || (_cache[8] = _createElementVNode("label", { class: "form-control-label" }, "事業所", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.tag.group2Id) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (state.tag.group3Id = null))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groups2, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_6))
            }), 128))
          ], 544), [
            [_vModelSelect, state.tag.group2Id]
          ])
        ], 512), [
          [_vShow, state.showEditDetail]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _cache[10] || (_cache[10] = _createElementVNode("label", { class: "form-control-label group2" }, "部署", -1)),
          _withDirectives(_createElementVNode("select", {
            class: "form-control",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.tag.group3Id) = $event))
          }, [
            _cache[9] || (_cache[9] = _createElementVNode("option", { value: null }, null, -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups3.value, (e) => {
              return (_openBlock(), _createElementBlock("option", {
                key: e.id,
                value: e.id
              }, _toDisplayString(e.name), 9, _hoisted_8))
            }), 128))
          ], 512), [
            [_vModelSelect, state.tag.group3Id]
          ])
        ], 512), [
          [_vShow, state.showEditDetail]
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.httpErrorMsgs, (e, i) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "error",
              key: i
            }, _toDisplayString(e), 1))
          }), 128))
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isCloseButtonDisabled"]))
}
}

})